import React from "react"
import PropTypes from "prop-types"
import styles from "./BookingForm.module.css"

const Stepper = ({ activeStep = 1, t }) => {
  const steps = [
    { id: 1, label: t("booking.client_experience_details") },
    { id: 2, label: t("booking.price_payment_information") }
  ]

  return (
    <div className={styles.customTabs} role="tablist" aria-label={t("booking.steps_label")}>
      {steps.map(({ id, label }) => (
        <button
          key={id}
          type="button"
          role="tab"
          aria-selected={activeStep === id}
          className={`${styles.tabItem} ${activeStep === id ? styles.tabItemActive : ""}`}
          disabled
          aria-disabled
        >
          <span className={styles.tabBadge}>{id}</span>
          {label}
        </button>
      ))}
    </div>
  )
}

Stepper.propTypes = {
  activeStep: PropTypes.number,
  t: PropTypes.func.isRequired
}

export default Stepper
